import { Activity } from 'react';

import { useTranslation } from '@mint-lib/i18n';
import {
  DataImportHub as DataImportHubIcon,
  Hierarchy as HierarchyIcon,
  Wikis as WikisIcon,
} from '@mint-lib/icons';
import { Tabs, TabsList, TabsTrigger } from '@mint-lib/tw-components';

type Props = {
  activeTab: string;
  onChangeTab: (tab: string) => void;
  isWebsourceVisible: boolean;
  isStepsVisible: boolean;
  isKnowledgeVisible: boolean;
};

const ProcessDetailsTabs = ({
  activeTab,
  onChangeTab,
  isWebsourceVisible,
  isStepsVisible,
  isKnowledgeVisible,
}: Props) => {
  const { t } = useTranslation('@mint-lib/ai-chat');

  return (
    <Tabs
      orientation="horizontal"
      value={activeTab}
      onValueChange={onChangeTab}
      className="scrollbar-hide flex gap-2 overflow-x-auto"
    >
      <TabsList>
        <Activity mode={isStepsVisible ? 'visible' : 'hidden'}>
          <TabsTrigger
            value="reasoning"
            className="flex-shrink-0 whitespace-nowrap"
          >
            <HierarchyIcon />
            {t('Reasoning steps')}
          </TabsTrigger>
        </Activity>
        <Activity mode={isKnowledgeVisible ? 'visible' : 'hidden'}>
          <TabsTrigger
            value="knowledgeBase"
            className="flex-shrink-0 whitespace-nowrap"
          >
            <DataImportHubIcon />
            {t('Knowledge base')}
          </TabsTrigger>
        </Activity>
        <Activity mode={isWebsourceVisible ? 'visible' : 'hidden'}>
          <TabsTrigger
            value="webSources"
            className="flex-shrink-0 whitespace-nowrap"
          >
            <WikisIcon />
            {t('Sources')}
          </TabsTrigger>
        </Activity>
      </TabsList>
    </Tabs>
  );
};

export { ProcessDetailsTabs };
